import React, { useState } from 'react';
import { CONTENT_TOP } from 'dashboard/layouts/admin/chromeGeometry';
import { Box, Tab, Tabs } from '@mui/material';
import { useOutletContext } from 'react-router';
import { EmptyState, PageHeader, PagePaper, folderTabs } from 'dashboard/components/common';
import ProductsTab from './ProductsTab';
import WarehousesTab from './WarehousesTab';
import InventoryTab from './InventoryTab';

/**
 * Catalog, warehouses, and stock matrix. Each tab is its own file —
 * keeps this entry tiny and lets us extend the dialogs in isolation.
 */
export default function Ecommerce() {
  const [selectedBrand] = useOutletContext();
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ pt: CONTENT_TOP }}>
      <PagePaper>
        <PageHeader
          title='Commerce'
          subtitle='Catalog, locations, and inventory for your brand store. Sales reduce stock automatically; production runs add it back.'
        />

        {!selectedBrand ? (
          <EmptyState>Select a brand to manage commerce.</EmptyState>
        ) : (
          <Box>
            <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ ...folderTabs, mb: '16px' }}>
              <Tab label='Products' />
              <Tab label='Warehouses' />
              <Tab label='Inventory' />
            </Tabs>
            {tab === 0 && <ProductsTab brandId={selectedBrand} />}
            {tab === 1 && <WarehousesTab brandId={selectedBrand} />}
            {tab === 2 && <InventoryTab brandId={selectedBrand} />}
          </Box>
        )}
      </PagePaper>
    </Box>
  );
}
